import React from 'react';

const CheckoutHeader = ({ checkoutHeaderImg, customerFirstName, contractType}) => (
  <div className="checkoutNew-recap-header">
    <img className="checkoutNew-recap-header-img" src={checkoutHeaderImg} alt="" />
    <h3 className="checkoutNew-recap-header-title">{`Merci${customerFirstName}, vous avez presque terminé !`}</h3>
    <p className="checkoutNew-recap-header-subtitle">
      {`Une fois que vous aurez terminé ce questionnaire, nous allons entamer les démarches pour créer votre ${contractType}`}</p>
  </div>
);

export default CheckoutHeader;



// WEBPACK FOOTER //
// ./src/components/buy/Checkout/CheckoutHeader.js